import React, {useState} from 'react';
import Translate from "../../components/Translate";
import {isValidTime, silverInfoStyles} from "../../utils/General";
import Colors from "../../utils/Colors";
import Input from "./Input";

const timeInputStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        marginBottom: '20px',
    },
    label: {
        fontSize: '14px',
        color: Colors.silverBlueLite,
        fontWeight: '500',
    },
    inputError: {
        borderColor: '#ff4d4f',
        backgroundColor: '#fff1f0',
    }
};

const TimeInput = ({label, name, value, onChange, disabled = false, containerStyles = {}, inputStyles = {}}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleBlur = () => {
        setIsFocused(false);
        setHasError(!isValidTime(value));
    };

    const handleInputChange = (e) => {
        const val = e.target.value;

        if (/^[0-9:]{0,5}$/.test(val)) {
            if (val.length === 3 && !val.includes(':')) {
                e.target.value = val.substring(0, 2) + ':' + val.substring(2, 3);
            }
            onChange(e);
        }
    };

    return (
        <div style={{...timeInputStyles.container, ...containerStyles}}>
            <span style={{...silverInfoStyles.info, marginLeft: '0px'}}><Translate text={label}/></span>
            <Input
                type="text"
                name={name}
                value={value}
                placeholder="HH:mm"
                onChange={handleInputChange}
                onClick={e => e.stopPropagation()}
                onFocus={(e) => {
                    e.stopPropagation()
                    setIsFocused(true)
                }}
                onBlur={handleBlur}
                style={{
                    ...(hasError ? timeInputStyles.inputError : {}),
                    ...inputStyles,
                }}
                maxLength={5}
                disabled={disabled}
            />
        </div>
    );
};

export default TimeInput;



// WEBPACK FOOTER //
// ./src/components-new/form/TimeInput.jsx